import { RefreshCw, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { BUILD_ID } from '../generated-version';

interface VersionManifest { version?: string }

export function UpdateManager() {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    let active = true;
    const check = async () => {
      if (document.visibilityState === 'hidden') return;
      try {
        const response = await fetch(`/version.json?v=${Date.now()}`, { cache: 'no-store' });
        const manifest = await response.json() as VersionManifest;
        if (active && manifest.version && manifest.version !== BUILD_ID) setAvailable(true);
      } catch { /* A failed update check never interrupts committee work. */ }
    };
    const visibility = () => { if (document.visibilityState === 'visible') void check(); };
    const timer = setInterval(() => void check(), 60_000);
    const first = setTimeout(() => void check(), 8_000);
    addEventListener('online', check); document.addEventListener('visibilitychange', visibility);
    return () => {
      active = false; clearInterval(timer); clearTimeout(first);
      removeEventListener('online', check); document.removeEventListener('visibilitychange', visibility);
    };
  }, []);

  if (!available) return null;
  return <aside className="update-notice" role="status" aria-live="polite">
    <div><strong>A new update is here</strong></div>
    <button className="update-action" onClick={() => location.reload()}><RefreshCw /> Update now</button>
    <button className="update-dismiss" aria-label="Dismiss update notice" onClick={() => setAvailable(false)}><X /></button>
  </aside>;
}
